import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { ListItemText, Typography } from '@material-ui/core';
import variables from '../../../Sys/variable.scss';

const useStyles = makeStyles((theme) => ({
    menuItem: {
        marginBottom: theme.spacing(0.5),
        marginLeft: theme.spacing(1),
        borderRadius: 8,
        minHeight: 38,
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        transition: 'background-color 0.15s ease, color 0.15s ease',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        '&.Mui-selected': {
            backgroundColor: `${variables.sidebarActive} !important`,
            '&:hover': {
                backgroundColor: `${variables.sidebarActive} !important`,
            },
        },
        '&.Mui-selected $menuItemText, &.Mui-selected $menuItemText.MuiTypography-body1': {
            color: '#fff',
        },
        '&.Mui-selected $menuIcon': {
            color: '#fff',
            opacity: 1,
        },
    },
    menuIcon: {
        minWidth: 32,
        color: variables.darkThemeText,
        opacity: 0.72,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiSvgIcon-root': {
            fontSize: '1.125rem',
        },
    },
    menuItemText: {
        color: variables.darkThemeText,
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: 1.35,
        '&.MuiTypography-body1': {
            color: variables.darkThemeText,
            fontSize: '0.75rem',
            fontWeight: 500,
            lineHeight: 1.35,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.75rem',
            '&.MuiTypography-body1': {
                fontSize: '0.75rem',
            },
        },
    },
}));

const DropDownMenu = ({ submenus, handleItemClick, location }) => {
    const classes = useStyles();
    return (
        <ul className="dropdown" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
            {submenus.map((submenu, index) => {
                const isSelected = location.pathname.startsWith(submenu.active) || false;
                return (
                    <ListItem
                        data-testid={`sidebar-item-${submenu.title.toLowerCase().replace(/\s+/g, '-')}`}
                        onClick={() => handleItemClick(submenu.active)}
                        className={classes.menuItem}
                        selected={isSelected}
                        button
                        key={index}
                    >
                        <ListItemIcon className={classes.menuIcon}>{submenu.icon}</ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography className={classes.menuItemText}>{submenu.title}</Typography>
                            }
                        />
                    </ListItem>
                );
            })}
        </ul>
    );
}

export default DropDownMenu;
